import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-grid-1",
  "use": "icon-grid-1-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-grid-1\"><defs><style>#icon-grid-1 .cls-1{fill:#0df;}</style></defs><g id=\"icon-grid-1_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-grid-1_圖層_1-2\" data-name=\"圖層 1\"><rect class=\"cls-1\" width=\"7\" height=\"7\" /><rect class=\"cls-1\" y=\"10\" width=\"7\" height=\"7\" /><rect class=\"cls-1\" x=\"10\" width=\"7\" height=\"7\" /><rect class=\"cls-1\" x=\"10\" y=\"10\" width=\"7\" height=\"7\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol